module.exports = __webpack_public_path__ + "f4f98f804134376f42deffcb8784a93b.mp4";